export default {
  "server.add": "Add WSL server",
  "server.label": "WSL",
  "server.menu.label": "WSL server",
  "server.retryStart": "Retry start",
  "server.updating": "Updating…",
  "onboarding.restartRequired": "Windows needs a restart to finish installing WSL.",
  "onboarding.distroNotInstalled": "{{distro}} is not installed yet.",
  "onboarding.openDistroOnce": "Open {{distro}} once to finish setup.",
  "onboarding.updatingOpencode": "Updating OpenCode…",
  "onboarding.updateOpencode": "Update OpenCode",
  "onboarding.installOpencode": "Install OpenCode",
  "onboarding.installedDistros": "Installed distros",
  "onboarding.checkAgain": "Check again",
  "onboarding.distroStatus.ready": "Ready",
  "onboarding.distroStatus.checking": "Checking…",
  "onboarding.distroStatus.opencodeMissing": "OpenCode not installed",
  "onboarding.distroStatus.missingTools": "Missing bash, curl",
  "onboarding.distroStatus.unsupported": "Unsupported · Use WSL 2",
  "onboarding.needAnotherDistro": "Need another distro?",
  "onboarding.needAnotherDistroHint": "Install a Linux distribution from the WSL catalog",
  "onboarding.wslNotInstalled.title": "WSL not installed",
  "onboarding.wslNotInstalled.description":
    "WSL (Windows Subsystem for Linux) is required before OpenCode can add a WSL server",
  "onboarding.wslUnavailable.title": "WSL unavailable",
  "onboarding.wslUnavailable.description": "OpenCode could not verify WSL on this machine.",
  "onboarding.installWsl": "Install WSL",
  "onboarding.windowsRestartRequired": "Restart Windows to finish installing WSL, then reopen OpenCode.",
  "onboarding.allDistrosAdded": "All installed distros are already added.",
  "onboarding.noDistros": "No distros detected yet.",
  "onboarding.installDistro": "Install distro",
  "onboarding.searchDistros": "Search distros",
  "onboarding.adding": "Adding…",
  "error.unavailable": "WSL is unavailable",
  "error.listInstalled": "Failed to list installed WSL distros",
  "error.listOnline": "Failed to list online WSL distros",
  "error.executeDistro": "Cannot execute commands in distro",
  "error.installWsl": "WSL installation failed",
  "error.installDistro": "Failed to install distro: {{distro}}",
  "error.installOpencode": "OpenCode installation failed",
  "error.alreadyAdded": "{{distro}} is already added",
  "error.opencodeMissing": "opencode is not installed in this distro",
  "error.opencodeCannotRun": "opencode is installed but could not run",
  "error.opencodeNotInstalled": "OpenCode is not installed in {{distro}}",
  "error.updateVersion": "OpenCode update finished but {{distro}} still reports {{installed}}; expected {{expected}}",
  "error.noVersion": "no version",
  "error.serverExited": "WSL server exited after startup (code={{code}} signal={{signal}})",
  "error.serverExitedBeforeHealthy":
    "WSL server exited before becoming healthy (code={{code}} signal={{signal}}){{output}}",
  "error.healthTimeout": "Sidecar for {{distro}} health check timed out after {{timeout}}ms",
  "error.commandTimeout": "{{command}} {{args}} timed out after {{timeout}}ms",
  "error.failedPort": "Failed to get port",
  "menu.remove": "Remove",
}
